import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function  Mumbaitomatherancab() {



  const cardData = {
    keyword: " Mumbai to Matheran Cab",


"headingDescription": "Royal Route Cab offers reliable and comfortable Mumbai to Matheran cab services, ensuring a smooth, safe, and scenic journey for families, couples, and weekend travelers. Matheran is a unique eco-friendly hill station where private vehicles are restricted beyond a certain point, making the journey from Mumbai a combination of cab travel up to Dasturi Naka followed by a toy train ride, horseback ride, or walking experience. The Mumbai to Matheran route covers approximately 80 to 90 km to the base point and takes around 2 to 2.5 hours depending on traffic conditions. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for all types of travelers. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted partner for Mumbai to Matheran travel.",

"topPlaces": [
  {
    "title": "Charlotte Lake",
    "description": "Charlotte Lake is the main water source of Matheran and one of its most peaceful attractions. Surrounded by dense greenery, it offers a calm environment ideal for relaxation, birdwatching, and nature walks. During monsoon and post-monsoon seasons, the lake becomes even more scenic with flowing streams and mist-covered surroundings."
  },
  {
    "title": "Panorama Point",
    "description": "Panorama Point is one of the most famous viewpoints in Matheran, offering a breathtaking 360-degree view of the Sahyadri mountains. It is especially popular for sunrise views, where visitors can witness the sky changing colors over valleys and distant hills."
  },
  {
    "title": "Louisa Point",
    "description": "Louisa Point is known for its stunning views of Prabal Fort, waterfalls during monsoon, and deep green valleys. It is a favorite photography spot where travelers can enjoy cool breezes and panoramic landscapes."
  },
  {
    "title": "Echo Point",
    "description": "Echo Point is a fun and scenic attraction where visitors can shout and hear their voices echo across the hills. It offers wide valley views, cool air, and is a popular stop for families and groups exploring Matheran."
  },
  {
    "title": "One Tree Hill Point",
    "description": "One Tree Hill Point is a unique viewpoint marked by a single large tree standing on a hilltop. It is popular among trekkers for its adventurous trail and offers peaceful surroundings with beautiful valley views."
  },
  {
    "title": "King George Point",
    "description": "King George Point is a scenic viewpoint offering stunning views of waterfalls and deep valleys, especially vibrant during monsoon season. It is a peaceful location ideal for relaxation and photography."
  },
  {
    "title": "Alexander Point",
    "description": "Alexander Point offers panoramic views of lush green valleys, nearby villages, and distant forts. It is a calm and less crowded viewpoint, perfect for enjoying nature at a relaxed pace."
  },
  {
    "title": "Porcupine Point (Sunset Point)",
    "description": "Porcupine Point is one of the best sunset viewpoints in Matheran, known for its dramatic cliffs and glowing skies during evening hours. It provides a perfect end-of-day experience for travelers."
  },
  {
    "title": "Matheran Toy Train Route",
    "description": "The Matheran toy train route is a UNESCO-recognized heritage experience that runs between Neral and Matheran. The scenic ride passes through tunnels, bridges, and lush green forests, making it one of the most memorable parts of the journey."
  },
  {
    "title": "Dasturi Naka",
    "description": "Dasturi Naka is the last motorable point before entering Matheran hill station. From here, travelers continue their journey on foot, horseback, or by hand-pulled carts, experiencing the unique eco-friendly charm of Matheran."
  }
],







services: [
  {
    name: "Mumbai to Matheran Cab",
    description: "Mumbai to Matheran cab service offers a refreshing journey to one of Maharashtra’s most peaceful hill stations. Known for its eco-friendly environment and scenic viewpoints, Matheran is a perfect weekend getaway. The cab journey up to Dasturi Naka is smooth and comfortable, followed by a short walk or horse ride to the hilltop. Ideal for families, couples, and tourists, this service ensures safe travel with experienced drivers. Multiple vehicle options are available. It guarantees a relaxing trip."
  },
  {
    name: "Mumbai to Matheran Taxi",
    description: "Mumbai to Matheran taxi provides convenient and private travel with door-to-door pickup. This service is perfect for travelers looking for a comfortable ride to the base point of Matheran. Vehicles are well-maintained and driven by experienced chauffeurs. Suitable for weekend trips and short vacations. It ensures a smooth and enjoyable journey."
  },
  {
    name: "Mumbai to Matheran Cab Service",
    description: "Mumbai to Matheran cab service is designed for quick and comfortable travel to this scenic hill destination. The route offers beautiful greenery and pleasant weather throughout the year. This service is ideal for families, couples, and group outings. Vehicles are maintained for highway and hill travel. It ensures a reliable journey."
  },
  {
    name: "Mumbai to Matheran Taxi Service",
    description: "Mumbai to Matheran taxi service offers dependable travel with a focus on comfort and safety. This service is suitable for tourists and families planning a hill station visit. Clean vehicles and trained drivers ensure a pleasant ride. Flexible scheduling allows easy trip planning. It guarantees a stress-free experience."
  },
  {
    name: "Cab from Mumbai to Matheran",
    description: "Cab from Mumbai to Matheran provides a personalized travel experience with flexible stops along the route. Travelers can enjoy scenic views before reaching the base of the hill station. This service is ideal for families and small groups. Professional drivers ensure safe travel. It offers a relaxed road trip."
  },
  {
    name: "Taxi from Mumbai to Matheran",
    description: "Taxi from Mumbai to Matheran offers a convenient and efficient way to reach this eco-sensitive hill station. With experienced drivers and comfortable vehicles, the journey is smooth and enjoyable. Door-to-door pickup adds convenience. Suitable for short trips and weekend travel. It ensures a reliable journey."
  },
  {
    name: "Mumbai to Matheran Cab Booking",
    description: "Mumbai to Matheran cab booking allows customers to reserve their ride easily with flexible options. Travelers can select vehicle type, pickup location, and timing. Instant confirmation and transparent pricing ensure a hassle-free process. It simplifies travel planning."
  },
  {
    name: "Mumbai to Matheran Taxi Booking Online",
    description: "Mumbai to Matheran taxi booking online provides a quick and convenient way to plan your journey. Customers can compare vehicle options and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures availability during peak travel times."
  },
  {
    name: "Mumbai to Matheran Cab Price",
    description: "Mumbai to Matheran cab price varies based on vehicle type, travel timing, and trip type. Transparent pricing ensures no hidden charges. Budget-friendly sedan options and premium SUVs are available. It helps travelers plan their trip efficiently. It ensures value for money."
  },
  {
    name: "Mumbai to Matheran Taxi Fare",
    description: "Mumbai to Matheran taxi fare is designed to be affordable and competitive for short-distance hill travel. Fare depends on vehicle type and travel plan. Customers receive clear pricing details before booking. Multiple options suit different budgets. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Matheran One Way Cab",
    description: "Mumbai to Matheran one way cab is a cost-effective option for travelers needing a single-side drop to the base point. This service eliminates return charges and offers flexible travel timings. Ideal for quick getaways. Comfortable vehicles ensure a smooth ride. It is perfect for budget travel."
  },
  {
    name: "Mumbai to Matheran Round Trip Taxi",
    description: "Mumbai to Matheran round trip taxi is ideal for travelers planning a same-day or weekend return trip. This package includes pickup, drop, waiting time, and return travel. Flexible schedules make it convenient. Suitable for family outings and sightseeing. It ensures comfort and efficiency."
  },
  {
    name: "Mumbai to Matheran Innova Cab",
    description: "Mumbai to Matheran Innova cab is perfect for families and groups seeking spacious and comfortable travel. The vehicle offers ample seating and luggage space. Ideal for group trips. Professional drivers ensure safety. It provides a premium travel experience."
  },
  {
    name: "Mumbai to Matheran Ertiga Cab",
    description: "Mumbai to Matheran Ertiga cab is suitable for small groups and families looking for an affordable yet spacious ride. This vehicle offers comfortable seating and good mileage. It is ideal for budget-friendly travel. Drivers ensure smooth journeys. It ensures a pleasant experience."
  },
  {
    name: "Mumbai to Matheran Sedan Cab",
    description: "Mumbai to Matheran sedan cab is ideal for couples and small families seeking economical travel. Sedans offer smooth driving and comfort for short-distance trips. This option is widely preferred for its affordability. Professional drivers ensure safe travel. It is perfect for a quick journey."
  },
  {
    name: "Mumbai to Matheran SUV Taxi",
    description: "Mumbai to Matheran SUV taxi provides extra space and comfort for group travel. SUVs offer better stability and performance on highways and hill routes. This option is ideal for families and corporate groups. Drivers ensure safe and reliable travel. It delivers a comfortable experience."
  },
  {
    name: "Cheap Mumbai to Matheran Cab",
    description: "Cheap Mumbai to Matheran cab offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Economical sedan options help reduce travel costs. Transparent pricing ensures no hidden charges. It is perfect for affordable trips."
  },
  {
    name: "Best Mumbai to Matheran Taxi Service",
    description: "Best Mumbai to Matheran taxi service ensures a premium travel experience with top-quality vehicles and professional drivers. This service focuses on punctuality, safety, and customer satisfaction. Multiple vehicle options are available for different needs. Transparent pricing builds trust. It guarantees a reliable and comfortable journey."
  }
],

tableData: [
  ["Mumbai to Matheran Cab", "Mumbai to Matheran Taxi"],
  ["Mumbai to Matheran Cab Service", "Mumbai to Matheran Taxi Service"],
  ["Cab from Mumbai to Matheran", "Taxi from Mumbai to Matheran"],
  ["Mumbai to Matheran Cab Booking", "Mumbai to Matheran Taxi Booking Online"],
  ["Mumbai to Matheran Cab Price", "Mumbai to Matheran Taxi Fare"],
  ["Mumbai to Matheran One Way Cab", "Mumbai to Matheran Round Trip Taxi"],
  ["Mumbai to Matheran Innova Cab", "Mumbai to Matheran Ertiga Cab"],
  ["Mumbai to Matheran Sedan Cab", "Mumbai to Matheran SUV Taxi"],
  ["Cheap Mumbai to Matheran Cab", "Best Mumbai to Matheran Taxi Service"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Matheran Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Mumbai to Matheran cab service, perfect for weekend getaways, nature trips, and family outings."
  },
  {
    WhyChooseheading: "Experienced Hill Route Drivers",
    WhyChoosedescription: "Our drivers are skilled in handling hilly and ghat routes, ensuring safe and secure travel up to Matheran entry point."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Matheran cab service operates 24/7, allowing flexible travel plans anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned to ensure a comfortable travel experience."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or same-day return options for Matheran trips."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for families and group travel."
  },
  {
    WhyChooseheading: "Trusted Weekend Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai to Matheran cab bookings due to punctual service and reliable drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Matheran cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Matheran for both one-way and round trips." },
  { question: "What is the distance between Mumbai and Matheran?", answer: "The distance is approximately 80 to 100 km and takes around 2.5 to 3.5 hours depending on traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Matheran cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I go directly to Matheran by car?", answer: "Cars are allowed only up to Dasturi Naka, after which you can travel by toy train, horse, or walk." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, and airport anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended, especially during weekends and peak tourist seasons." },
  { question: "Do you provide same-day return trips?", answer: "Yes, we offer same-day return cab services for Mumbai to Matheran trips." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Avinash Deshmukh",
    feedback: "The Mumbai to Matheran cab service with Royal Route Cabs was very smooth and convenient. The driver managed the route well up to the drop point and ensured a comfortable journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback: "Excellent experience traveling from Mumbai to Matheran. The cab was clean, the ride was safe, and the service felt reliable and well-coordinated.",
    rating: 5
  }
];





















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Matheran Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-matheran-cab.jpg", // replace if needed
  "description": "Book Mumbai to Matheran cab with Royal Route Cabs for a comfortable hill station travel experience. Choose from sedan, SUV, Innova, and luxury cars for one-way and round-trip taxi service with 24x7 availability and professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2000", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-matheran-cab"
  }
};






  return (
    <div>
<Helmet>
  <title>Mumbai to Matheran Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Matheran cab at best price with Royal Route Cabs. One-way & round-trip taxi service with sedan, SUV, Innova & luxury cars. Safe, reliable & 24x7 available."
  />

  <meta
    name="keywords"
    content="mumbai to matheran cab, mumbai to matheran taxi, mumbai to matheran cab service, mumbai to matheran taxi service, cab from mumbai to matheran, taxi from mumbai to matheran, mumbai to matheran cab booking, mumbai to matheran taxi booking online, mumbai to matheran cab price, mumbai to matheran taxi fare, mumbai to matheran one way cab, mumbai to matheran round trip taxi, mumbai to matheran innova cab, mumbai to matheran ertiga cab, mumbai to matheran sedan cab, mumbai to matheran suv taxi, cheap mumbai to matheran cab, best mumbai to matheran taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/15.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitomatherancab;